// plugins/vue-js-modal.js
import Vue from 'vue'
import VModal from 'vue-js-modal/dist/ssr.nocss'
import LoginDialog from '~/components/navigation-bar/dialog/loginDialog.vue'
import DetailOpenVip from '~/components/detail/open-vip.vue'

import 'vue-js-modal/dist/styles.css'
import '~/styles/vue-js-modal.scss'

Vue.use(VModal, {
  dynamic: true,
  injectModalsContainer: true,
  dynamicDefaults: {
    clickToClose: true,
    draggable: false,
    resizable: true,
    scrollable: true,
    height: 'auto',
    classes: ['vue-modal-content']
  }
})

const showLoginDialogFunction = function (props = {}, cbOpt = {}) {
  this.$modal &&
    this.$modal.show(
      LoginDialog,
      {
        ...props
      },
      {
        width: 600,
        height: 460
      },
      {
        ...cbOpt
      }
    )
}

const showDetailOpenVipFunction = function (props = {}, cbOpt = {}) {
  this.$modal &&
    this.$modal.show(
      DetailOpenVip,
      {
        ...props
      },
      {
        width: 600,
        height: 460
      },
      {
        ...cbOpt
      }
    )
}

Vue.prototype.$showLoginDialogFunction = showLoginDialogFunction
Vue.prototype.$showDetailOpenVipFunction = showDetailOpenVipFunction

// export default function (_, inject) {

//   inject('showLoginDialogFunction', showLoginDialogFunction)
// }
